/**
 * Classes shared by the filter dialog's two lists (filter fields and column
 * visibility), so the tabs keep matching by construction rather than by
 * copy-paste.
 */

/** Uppercase heading naming the list below it. */
export const GROUP_HEADING_CLASS =
  "px-3 pt-2.5 pb-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground/70";
